module.exports = __webpack_public_path__ + "img/9_108.163ef8d0.png";